// Показатели таблицы друзей. Порядок — порядок кнопок сортировки.
export const FRIENDS_METRICS = [
  "score",
  "winRate",
  "kda",
  "soulsPerMinute",
  "deaths",
  "rank",
  "matches",
] as const;

export type FriendsMetric = (typeof FRIENDS_METRICS)[number];

export const DEFAULT_FRIENDS_METRIC: FriendsMetric = "score";

// Где меньше — лучше: только смерти за матч.
export const LOWER_IS_BETTER: ReadonlySet<FriendsMetric> = new Set(["deaths"]);
